import React from 'react';
import './WhyUs.css';

import { Heading } from '../../../components';
import { whyChooseUs } from '../../../constants';



const WhyChooseUs = () => {

  return (
    <section className="custom-form why-us">
      <div className="box-container">
        <div className="content">
          <div className="text">

            {/* Section Heading */}
            <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} sideHeading linear />

            <p>{whyChooseUs.content}</p>

            {/* Key Benefits */}
            <div className="why-points">
              {whyChooseUs.points.map((point) => (
                <div className="box" key={point.id}>
                  <h3>
                    {point.title}
                    <span> {point.progress}% </span>
                  </h3>
                  <div className="progress-bar">
                    <span style={{ width: `${point.progress}%` }}></span>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;